import $ from 'jquery';
import AbstractBlock from './abstractBlock.js';
import { ftrim, clearspaces } from 'lib/strings.js';
import CSRF from 'lib/csrf.js';

export default class RequestBlock extends AbstractBlock {
    xhr = null;
    loading = false;

    /**
     * Инициализируем поведение
     *
     * @param {jquery} element
     */
    init(element) {
        this.element = element.find('.js-enter_info_request');
        if (!this.hasElement) {
            console.warn('Request Block no element');
            return;
        }

        this.element.on('click', '.js-cancel', ::this.cancel);

        this.input = this.element.find('.js-input');
        this.errorElement = this.element.find('.js-error');
        this.formGroup = this.input.parents('.form-group');

        if (this.input && this.input.length) {
            this.input.on('keyup change', () => {
                this.error = false;
            });
            this.element.on('click', '.js-confirm', ::this.confirm);
        }
        console.log('Request Block inited');
    }

    set val(value) {
        if (this.input && this.input.length) {
            this.input.val(value);
        }
        this.error = false;
    }

    get val() {
        if (this.input && this.input.length) {
            return ftrim(clearspaces(this.input.val() || ''));
        }

        return null;
    }

    set error(value) {
        const errorElementExist =
            !!this.errorElement && this.errorElement.length;
        const formGroupExist = !!this.formGroup && this.formGroup.length;

        if (!value) {
            if (!this.errorValue) {
                return;
            }

            this.errorValue = false;
            if (errorElementExist) {
                this.errorElement.hide().html('');
            }

            if (formGroupExist) {
                this.formGroup.removeClass('has-error');
            }
        } else {
            this.errorValue = value;
            if (errorElementExist) {
                this.errorElement.html(value).show();
            }

            if (formGroupExist) {
                this.formGroup.addClass('has-error');
            }
        }
    }

    confirm() {
        if (this.loading) {
            return;
        }

        const value = this.val;

        if (!value) {
            this.error = 'Введите адрес вашего дома';
            return;
        }

        this.xhr = $.ajax({
            url: '/housing/add-house-request',
            dataType: 'json',
            method: 'POST',
            data: Object.assign(
                {
                    address: value,
                },
                CSRF.getByObject()
            ),
            beforeSend: () => {
                this.setLoading(true);
            },
            success: (response = {}) => {
                if (response.status !== 'ok') {
                    this.events.trigger('error');
                    return;
                }

                this.events.trigger('complete');
            },
            error: (xhr) => {
                if (xhr.status === 'abort') {
                    return;
                }

                this.events.trigger('error');
            },
            complete: () => {
                this.setLoading(false);
            },
        });
    }

    setLoading(value) {
        if (value) {
            this.element.addClass('loading');
            this.loading = true;
        } else {
            this.element.removeClass('loading');
            this.loading = false;
        }
    }

    cancel() {
        this.events.trigger('cancel');
    }

    /**
     * Сбросить данные
     */
    drop() {
        this.val = '';
    }

    /**
     * Отменить запрос
     */
    abort() {
        if (this.xhr) {
            this.xhr.abort();
            this.xhr = null;
        }
    }
}
